import { render, staticRenderFns } from "./MainFooterWorker.vue?vue&type=template&id=200291f6&scoped=true&"
import script from "./MainFooterWorker.vue?vue&type=script&lang=js&"
export * from "./MainFooterWorker.vue?vue&type=script&lang=js&"
import style0 from "./MainFooterWorker.vue?vue&type=style&index=0&id=200291f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200291f6",
  null
  
)

export default component.exports